export default __webpack_public_path__ + "static/media/undo.ba71c445.svg";